export default __webpack_public_path__ + "static/media/element_104.4e6e2ed1.jpg";